//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/date_box'
import 'devextreme/ui/list'
import 'devextreme/ui/popover'

//#endregion

import { LoggerService } from '../common.module'
import { DatePickerDirectiveController, CustomDatePeriod, DatePickerBridge } from './date-picker.directive.controller'
import { IUserSession } from '../../../helpers'

//#region Asset Imports

import './date-picker.scss'
import * as TEMPLATE from './date-picker.tpl.html'

//#endregion

export { CustomDatePeriod, DatePickerBridge }

export class DatePickerDirective implements ng.IDirective {
    scope = {
        "source": "="
    }
    restrict = 'E'
    controller = ['$scope', '$q', '$timeout', 'logger', 'userSession', ($scope: any, $q: ng.IQService, $timeout: ng.ITimeoutService, logger: LoggerService, userSession: IUserSession) => new DatePickerDirectiveController($scope, $q, $timeout, logger, userSession)]
    template = TEMPLATE
}